<template>
    <div class="row">
        <div class="col-12" v-if="!productChosen">
            <div class="form-group">
                <label>{{$t('COMMON.product')}}</label>
                <multiselect  v-model="productChosen"
                             @remove="productChosen = null"
                             :options="sortedProducts"
                             :close-on-select="true"
                             :hide-selected="false"
                             :preserve-search="true"
                             :multiple="false"
                             trackBy="id"
                             :custom-label="customProductLabel"
                             placeholder="Type"
                             style="z-index: 100;">
                    <template slot="tag" slot-scope="props">
                    <span class="custom__tag">
                        <span>{{ props.option }}</span>
                        <span class="custom__remove"
                              @click="props.remove(props.option)">
                            ❌
                        </span>
                    </span>
                    </template>
                </multiselect>
            </div>
        </div>
        <div class="col-12" v-if="productChosen">
            <h4 class="mt-2">{{$t('PROMOTIONS.standardPrice')}}: {{standardPrice}} {{symbol}}</h4>
            <div class="mt-3"></div>
                <div class="row">
                    <div class="col-6 col-xs-12">
                <regular-promotion :productChosen="productChosen"
                                :regularPromotions="regularPromotions"
                                @addPromotion="addPromotion($event)"
                                @removePromotion="$emit('removeFromStack', $event)"
                                @activate="activatePromotion($event)"
                                :showadd="showadd"
                                :noTable="true"
                                :symbol="symbol"
                                :fractionalDigits="fractionalDigits"
                                >
                </regular-promotion>
                </div>
                <div class="col-6 col-xs-12 border-left">
                <bulk-promotions :bulkPromotions="bulkPromotions"
                                :productChosen="productChosen"
                                v-if="showBulkPromotions"
                                @addPromotion="addPromotion($event)"
                                @removePromotion="$emit('removeFromStack', $event)"
                                @activate="activatePromotion($event)"
                                :showadd="showadd"
                                :noTable="true"
                                :symbol="symbol"
                                :fractionalDigits="fractionalDigits">
                </bulk-promotions>
                </div>
            </div>
            <!-- <fee v-if="false" :feeForProduct="true" @setFee="setFee" :symbol="symbol"></fee> -->
        </div>
    </div>
</template>
<script>
import CphButton from '../../Shared/UI/Button/CphButton.vue';
import Fee from '../../../views/Panel/Fee/Fee.vue';
import FormInput from '../../Shared/UI/Form/FormInput';
import Multiselect from 'vue-multiselect';
import BulkPromotions from './BulkPromotions';
import RegularPromotion from './RegularPromotion';
import { mapGetters, mapMutations, mapActions } from 'vuex';

export default {
    name: 'promotion-form',
    data () {
        return {
            newPromotion: null,
            newBulkPromotion: null,
            showBulkPromotions: true,
            symbol: '',
            fractionalDigits: 0,
        };
    },
    computed: {
        ...mapGetters({promotions : 'getPromotions', getActiveShop: 'getActiveShop'}),
        productPromotions () {
            if (!this.productChosen) {
                return [];
            }
            return this.promotions.filter(({productId}) => productId === this.productChosen.id);
        },
        bulkPromotions () {
            return this.productPromotions.filter(({type}) => type === 'bulk');
        },
        regularPromotions () {
            return this.productPromotions.filter(({type}) => type === 'period');
        },
        sortedProducts () {
            return this.alphabeticalSort(this.products);
        },
        standardPrice () {
            if (!this.productChosen) {
                return 0;
            }
            return this.productChosen.priceValue;
        },
        productChosen: {
            get (){
                return this.$props.editedProduct;
            },
            set (){

            }
        }
    },
    watch: {
        productChosen (newProduct) {
            this.getPromotions((newProduct));
        }
    },
    components: {
        RegularPromotion,
        BulkPromotions,
        CphButton,
        FormInput,
        Multiselect,
        Fee
    },
    props: {
        products: {
            type: [Array]
        },
        prices: {
            type: [Object]
        },
        editedProduct: {
            type: Object
        },
        showadd: {
            type: Boolean
        },
    },
    methods: {
        ...mapActions([
            'productsSaved',
            'GetShopById'
        ]),
        ...mapMutations(['updatePromotions']),
        ...mapGetters([ 'currentShop']),
        alphabeticalSort (arr) {
            return arr.sort((a, b) => a.type > b.type );
        },
        customProductLabel ({type, formats, code}) {
            return `${type} ${formats[0].displayString} ${code && code !== 'undefined' ? 'code: ' + code : ''}`;
        },
        setFee ({name, value}) {
            // To do
        },
        async addPromotion ({promotion, type}) {
            let shopId = this.$route.params.id;

            if(promotion.price && (promotion.quantity || (promotion.startTime && promotion.endTime))){
                try {
                    if (promotion.price > this.standardPrice) {
                        return this.$store.dispatch('confirmAction', {question: this.$t('QUESTIONS.higherPrice'), shouldGoToPrevPage: false,
                            callback: (decision = false) => {
                                if(decision) {
                                    this.$emit("addFunctionToSave", {id: `${type}-1`, run: () => this.$store.dispatch('addPromotionAsync', promotion)})
                                    this.$emit("addFunctionToSave", {id: `product-saved`, run: () => this.productsSaved({id: shopId})});
                                    this.$emit("addFunctionToSave", {id: `get-promotions`, run: () => this.getPromotions(this.productChosen)});
                                }
                            }});
                    } else {
                        this.$emit("addFunctionToSave", {id: `${type}-1`, run: () => this.$store.dispatch('addPromotionAsync', promotion)})
                        this.$emit("addFunctionToSave", {id: `product-saved`, run: () => this.productsSaved({id: shopId})});
                        this.$emit("addFunctionToSave", {id: `get-promotions`, run: () => this.getPromotions(this.productChosen)});
                    }
                } catch (err) {
                    console.log(err);
                }
            }
        },
        async removePromotion (id) {
            const updatedPromotions = this.productPromotions.filter((promo) => promo.id !== id);
            this.$store.dispatch('confirmAction', {question: this.$t('QUESTIONS.removePromotion'),
                callback: (decision = false) => {
                    if(decision) {
                        this.updatePromotions(updatedPromotions);
                        this.$emit('addFunctionToSave',  {
                            run: () => {
                                this.$store.dispatch('deletePromotionByIdAsync', id);
                            },
                            id: id
                        })
                    }
                }
            }).then(test => {
                console.log(test);
            })
        },
        async getPromotions (product) {
            let productPromotions = await this.$store.dispatch('getPromotionByProductIdAsync', product.id);
            if (this.$utils.isArray(productPromotions)) {
                this.promotions = productPromotions;
            }
        },
        async activatePromotion (promotion) {
            const acState = {...promotion, active: !promotion.active};
            this.$emit('addFunctionToSave',  {
                run: () => {
                    this.$store.dispatch('updatePromotionAsync', acState);
                },
                id: promotion.id
            });
            this.$set(promotion, 'active', !promotion.active);
            this.showBulkPromotions = false;
            this.$nextTick(() => this.showBulkPromotions = true);
        }
    },
    async created () {
        if(!this.currentShop.currency){
            const shop = await this.GetShopById(this.getActiveShop);
            const numberFormat = new Intl.NumberFormat('en', { style: 'currency', currency: shop?.currency?.code || "EUR" }).formatToParts(10000.10);
            this.symbol = numberFormat.find(x => x.type === 'currency').value;
            this.decimalSeparator = numberFormat.find(x => x.type === 'decimal').value;
            this.separator = numberFormat.find(x => x.type === 'group').value;
            this.fractionalDigits = shop?.currency?.fractionDigits || 2;
        }
    }
};
</script>
